<template>
  <div>
    <div class="product-style" v-if="isMobile">
      <toppage></toppage>
      <div class="product-main">
        <div class="mian-header">
          <div class="header-content">
            <h1>图链—虚拟货币智能研判系统</h1>

            <div class="header-bottom">
              <span>公安部经侦应用云推荐研判工具</span>
            </div>
          </div>
        </div>
        <div class="main-content">
       
          <h1>产品核心功能</h1>
          <span class="content-info"
            >产品以虚拟币地址为切入点，以链上交易溯源及匿名身份穿透为核心，用于打击涉虚拟货币新型犯罪的一站式查控平台，协助执法机关解决虚拟币案件中的各类数据分析、案情拆解、及分析研判难题。</span
          >
          <img src="../../assets/image/mobile/product/banner1.png" alt="">
          <h1>调证解析</h1>
          <span class="content-other">内置所有涉币平台调证方式，一键生成调证文书<br/>
系统支持所有主流交易所、钱包公司调证文件自动解析<br/>
全量调证用户列表展示，调证数据和链上数据可视化呈现</span>
<img src="../../assets/image/mobile/product/banner7.png" alt="">
<h1>数据看板</h1>
<span class="content-other">高洞察安全风险能力，快速感知链上数据态势<br/>案件数据实时更新，为分析决策提供行动依据<br/>交易数据实时监控，支持钉钉、微信、邮箱多端动态推送，及时知晓数据变动情况</span>
<img src="../../assets/image/mobile/product/banner3.png" alt="">
<h1>智能溯源追踪</h1>
<span class="content-other">精准挖掘各种主流货币关键交易环节，实现链上数据任意层级向前/后追溯，清晰化展示链路关系</span>
<img src="../../assets/image/mobile/product/banner6.png" alt="">     
<h1>数据标签</h1>
<span class="content-other">万亿级数据实时更新，6亿+标签，1800+万恶意标签<br/>1亿级疑似恶意灰地址标签，3.1亿+行为标签</span>
<img src="../../assets/image/mobile/product/banner4.png" alt=""> 
<h1>技战法模型</h1>
<span class="content-other">内置多种链上侦查技战法模型，智能定位匿名地址实控人</span>
<img src="../../assets/image/mobile/product/banner2.png" alt=""> 
<h1>司法判例</h1>
<span class="content-other">行业领先的涉币司法判例库，内含3000条以上的涉币司法判例供参考</span>
</div>
        <footerpage></footerpage>
      </div>
      <img class="scroll-button" v-if="showButton"  @click="scrollToTop" src="../../assets/image/newhome/huidaodingbu.png" alt="">

    </div>
    <div class="product-style" v-else>
      <full-page :options="options" ref="fullpage">
        <div class="section product-top">
          <div>
            <div class="product-nav">
              <navbar classname="product"></navbar>
            </div>
            <div class="section-content">
              <div class="top-title">
                <div class="title-content">
                  <h1>图链—虚拟货币智能研判系统</h1>
                  <h2>公安部经侦应用云推荐研判工具</h2>
                  <div class="info-content">
                    <a href="https://dashboard.graphchain.top" target="_blank"
                      >进入图链</a
                    >
                  </div>
                </div>
                <!-- <div class="title-info">

                  <div class="info-content">

<a href="https://dashboard.graphchain.top" target="_blank">进入图链</a>
</div>

           
                 
                </div> -->
                <!-- <div class="title-content">
             <img src="@/assets/image/newhome/businessintroduce/bannerbeijing.gif" alt="">
            </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="section product-profession">
          <div
            class="profession-content animated-element1"
            v-show="isprofession"
          >
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info">
                  <h1>产品核心功能</h1>
                  <p class="profession-title">
                    产品以虚拟币地址为切入点，以链上交易溯源及匿名身份穿透为核心，用于打击涉虚拟货币新型犯罪的一站式查控平台，协助执法机关解决虚拟币案件中的各类数据分析、案情拆解、及分析研判难题。
                  </p>
                  <div class="product-currency">
                    <!-- <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide ">
          <img src="../../assets/image/newhome/product/biaoqian.png" alt="">
          <span>司法判例</span>
         <p>3000+ , 行业领先的涉币司法判例库</p>
        </div>
        <div class="swiper-slide ">
          <img src="../../assets/image/newhome/product/biaoqian.png" alt="">
         <span>调证解析</span>
         <p>内置100+涉币平台调证方式，一键生成调证文书；支持多家主流交易所、主流钱包公司调证文件自动解析;单案件平均节约办案民警约100小时的数据研判时间</p>
        </div>
        <div class="swiper-slide ">
          <img src="../../assets/image/newhome/product/biaoqian.png" alt="">
         <h2>智能溯源追踪 <br>—画布功能</h2>
         <p>精准挖掘各种主流货币交易关键环节，实现任意层级向前/后追溯，形成更清晰化的链上溯源线索展示</p>
        </div>
        <div class="swiper-slide ">
          <img src="../../assets/image/newhome/product/biaoqian.png" alt="">
          <span>数据看板</span>
         <p>行业态势数据感知，高洞察安全风险能力，快速感知数据链上态势；案件数据实时更新，为数据决策提供行动依据交易数据实时监控，支持钉钉、微信、邮箱多端推送
</p>
        </div>
        <div class="swiper-slide ">
          <img src="../../assets/image/newhome/product/biaoqian.png" alt="">
          <span>数据标签</span>
         <p>0+主流公链解析及项目全解析，3.2亿标签，1200万恶意标签，1亿级疑似恶意灰地址标签</p>
         
        </div>
 
        <div class="swiper-slide ">
          <img src="../../assets/image/newhome/product/biaoqian.png" alt="">
          <span>技战法模型</span>
         <p>内置多种链上侦查技战法模型</p>
        </div>
        
      </div>
   
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>

  
    </div> -->
                    <div class="currency-content">
                      <div class="content-info">
                        <h2>调证解析</h2>
                        <span
                          >内置所有涉币平台调证方式，一键生成调证文书<br />
                          系统支持所有主流交易所、钱包公司调证文件自动解析<br />
                          全量调证用户列表展示，调证数据和链上数据可视化呈现</span
                        >
                      </div>
                      <div class="content-info">
                        <h2>智能溯源追踪</h2>
                        <span
                          >精准挖掘各种主流货币关键交易环节，实现链上数据任意层级向前/后追溯，清晰化展示链路关系</span
                        >
                      </div>
                      <div class="content-info">
                        <h2>数据看板</h2>
                        <span
                          >高洞察安全风险能力，快速感知链上数据态势<br />
                          案件数据实时更新，为分析决策提供行动依据<br />
                          交易数据实时监控，支持钉钉、微信、邮箱多端动态推送，及时知晓数据变动情况</span
                        >
                      </div>
                    </div>
                    <div class="currency-content1">
                      <div class="content-info">
                        <h2>技战法模型</h2>
                        <span>内置多种链上侦查技战法模型，智能定位匿名地址实控人</span>
                      </div>
                      <div class="content-info">
                        <h2>数据标签</h2>
                        <span
                          >万亿级数据实时更新，6亿+标签，1800+万恶意标签<br/>1亿级疑似恶意灰地址标签，3.1亿+行为标签</span
                        >
                      </div>
                      <div class="content-info">
                        <h2>司法判例</h2>
                        <span>行业领先的涉币司法判例库，内含3000条以上的涉币司法判例供参考</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="liucheng-button">
              <span>联系我们</span>
            </div> -->
              </div>
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
      </full-page>
      <div></div>
    </div>
  </div>
</template>
<script>
import navbar from "@/components/navbar.vue";
import newfooter from "@/components/newfooter.vue";
import Swiper from "swiper";
import toppage from "@/views/newhome/toppage.vue";
import footerpage from "@/views/newhome/footerpage.vue";
// import countTo  from 'vue-count-to';
// import CountUp from "countup"
export default {
  components: {
    navbar,
    newfooter,
    toppage,
    footerpage,
    // countTo
  },
  data() {
    return {
      showButton: false,
      scrollThreshold: 400,
      deviceType: this.getDeviceType(),
      // isshebi:false,
      isMobile: false,
      iscorebusiness1: false,
      iscorebusiness2: false,
      isprofession: false,
      screenWidth: 0,
      bannerHeight: 0,
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true,
        afterLoad: this.afterLoad,
        onLeave: this.onLeave,

        //为每个section设置背景色
        // sectionsColor: [
        //     "#41b883",
        //     "#ff5f45",
        //     "#0798ec",
        //     "#fec401",
        //     "#1bcee6",
        //     "#ee1a59",
        //     "#2c3e4f",
        //     "#ba5be9",
        //     "#b4b8ab"
        // ],
      },
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    getDeviceType() {
      return window.innerWidth < 768 ? "手机" : "电脑";
    },
    handleResize() {
      this.deviceType = this.getDeviceType();
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 1199;
    },
    //   onLeave(index, direction){
    //   console.log(index, direction);
    // },
    afterLoad(anchorLink, index) {
      console.log(anchorLink, index);
      console.log("Emitted 'after load' event.");
      //获取body的classname，跟随section滑动刷新
      let a = document.body.className;
      console.log(a);
      //在第几页控制相关逻辑
      //   if(a !== 'fp-scroll-mac fp-viewing-0' || a !== 'fp-viewing-0'){
      //     this.isshebi=false
      //   }

      if (a !== "fp-scroll-mac fp-viewing-1" || a !== "fp-viewing-1") {
        this.isprofession = false;
      }
      if (a === "fp-scroll-mac fp-viewing-1" || a === "fp-viewing-1") {
        // console.log(eee);
        this.isprofession = true;
      }
      // else if(a === 'fp-scroll-mac fp-viewing-0' || a === 'fp-viewing-0'){
      //   this.isshebi=true
      // }
    },

    next() {
      // 向下滚动一页
      this.$refs.fullpage.api.moveSectionUp();
      // this.$refs.fullpage.goTo(0);
    },
  },
  // created(){     location.reload()},
  mounted() {
    var mySwiper = new Swiper(".swiper-container", {
      // loop: true,
      loopAdditionalSlides: 1,
      width: window.innerWidth,
      slidesPerView: "auto",
      spaceBetween: 30,
      // width:30,
      // grabCursor : true,
      // initialSlide :1,

      // centeredSlides: true,
      // centeredSlidesBounds: true,
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    if (this.deviceType != "手机" && !this.isMobile) {
      this.next();
    }
    if(this.isMobile){

window.addEventListener('scroll', () => {
  this.showButton = window.scrollY > this.scrollThreshold;
});
}
      
    // 首次加载时,初始化高度
    // this.screenWidth = window.innerWidth;
    // this.bannerHeight = (450 / 1450) * this.screenWidth;
    // // 窗口大小发生改变
    // window.onresize = () => {
    //   this.screenWidth = window.innerWidth;
    //   this.bannerHeight = (450 / 1450) * this.screenWidth;
    // };
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('scroll', () => {});

  },
};
</script>
<style>
.fp-warning,
.fp-watermark {
  display: none !important;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/product.scss";
</style>
